import {
  ENDPOINT_CARTS,
  ENDPOINT_ITEMS,
  ENDPOINT_ROOT,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

// Update items quantity of a given cart
const postCartItems = ({ items, cart, type }) => {
  const params = { items: [...items], type };

  return axiosAuth
    .post(
      `${ENDPOINT_ROOT}/${ENDPOINT_CARTS}/${cart?.id}/${ENDPOINT_ITEMS}`,
      params,
    )
    .then((res) => res.data);
};

export default postCartItems;
